/**
 * Vertical Tabs
 * Handles the interactive tab navigation for industry use cases
 * and expandable feature items
 */

import { animateImageStackOnTabChange } from './scroll-animations'

export function initVerticalTabs() {
  const tabs = document.querySelectorAll<HTMLButtonElement>('.vertical-tab')
  const contents = document.querySelectorAll<HTMLElement>('.vertical-content')

  // Initialize tab switching
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetVertical = tab.dataset.vertical

      if (!targetVertical) return

      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove('active'))
      contents.forEach(c => c.classList.remove('active'))

      // Add active class to clicked tab and corresponding content
      tab.classList.add('active')

      const targetContent = document.querySelector<HTMLElement>(
        `.vertical-content[data-vertical="${targetVertical}"]`
      )

      if (targetContent) {
        targetContent.classList.add('active')

        // Trigger image stack animation when tab becomes visible
        animateImageStackOnTabChange(targetContent)
      }
    })
  })

  // Initialize expandable feature items
  initFeatureItems()
}

/**
 * Initialize expandable feature items with click behavior
 * Expands first item in each vertical by default
 */
function initFeatureItems() {
  // Get all feature items
  const featureItems = document.querySelectorAll<HTMLElement>('.feature-item')

  // Add click handlers to toggle expansion
  featureItems.forEach(item => {
    item.addEventListener('click', () => {
      item.classList.toggle('expanded')
    })
  })

  // Expand first item in each vertical by default
  const verticals = document.querySelectorAll<HTMLElement>('.vertical-content')
  verticals.forEach(vertical => {
    const firstItem = vertical.querySelector<HTMLElement>('.feature-item')
    if (firstItem) {
      firstItem.classList.add('expanded')
    }
  })
}
